import { useCallback, useEffect, useMemo, useState } from 'react';

import GameCard from 'components/sections/GameCard';

import Slider from '../Slider';
import { CasinoService } from 'api/casino';
import { Box, Stack, Typography } from '@mui/material';
import useTranslates from 'utils/translate';
import { useNavigate } from 'react-router-dom';
import useCategories from 'store/categories';
import AspectRatio from '../AspectRatio';
import NextArrow from '../Slider/NextArrow';
import PrevArrow from '../Slider/PrevArrow';
import useScreen from 'hooks/useScreen';

const CategorySlider = ({ categoryId, size }) => {
  const [games, setGames] = useState([]);
  const { translate } = useTranslates();
  const [categories] = useCategories();
  const navigate = useNavigate();

  const category = useMemo(
    () => categories.data.find((category) => category.id === categoryId),
    [categories.data, categoryId]
  );

  useEffect(() => {
    CasinoService.getGames({
      size,
      page: 1,
      category: categoryId,
    }).then((games) => {
      setGames(games.data);
    });
  }, [categoryId]);

  const { isMobile, isTablet } = useScreen();

  const openCategory = useCallback(() => {
    navigate(`/games/${category.uri}`);
  }, [category.uri]);

  if (games.length === 0) return null;

  const count = isTablet ? 4 : 8;
  const slidesToShow = games.length >= count ? count : games.length;

  return (
    <Box {...(isMobile && { width: '100vw', marginLeft: '-24px' })}>
      <Box display="flex" paddingLeft="16px" marginBottom="16px" justifyContent="space-between" paddingRight="16px">
        <Typography fontWeight={600} fontSize={isMobile ? 12 : 14}>
          {category.name}
        </Typography>
        <Typography fontWeight={600} fontSize={isMobile ? 12 : 14} onClick={openCategory}>
          {translate('more_games')}
        </Typography>
      </Box>
      {isMobile ? (
        <Stack
          className="hideScroll"
          direction="row"
          gap={1}
          style={{
            overflowX: 'auto',
          }}
        >
          {games.map((game) => (
            <Box key={game.id} minWidth="150px" height="113px">
              <GameCard game={game} height="100%" />
            </Box>
          ))}
        </Stack>
      ) : (
        <Slider
          infinite={false}
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToShow}
          nextArrow={
            <NextArrow hideIfNotSlide sx={{ right: 0, left: 'auto', bottom: 'auto', top: 'calc(50% - 20px)' }} />
          }
          prevArrow={
            <PrevArrow hideIfNotSlide sx={{ left: 0, right: 'auto', bottom: 'auto', top: 'calc(50% - 20px)' }} />
          }
        >
          {games.map((game) => (
            <AspectRatio key={game.id} {...(games.length < 3 && { size: 3 })} divide="4:3" spacing={1}>
              <GameCard game={game} height="100%" />
            </AspectRatio>
          ))}
        </Slider>
      )}
    </Box>
  );
};

export default CategorySlider;
